(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/views/system-rows-container.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/views/system-rows-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.eurojackpot=_svs.eurojackpot||{};
_svs.eurojackpot.components=_svs.eurojackpot.components||{};
_svs.eurojackpot.components.play=_svs.eurojackpot.components.play||{};
_svs.eurojackpot.components.play.templates=_svs.eurojackpot.components.play.templates||{};
svs.eurojackpot.components.play.templates.system_rows_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"boardContainerRegion\" class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3\"></div>\n<div id=\"systemSummaryRegion\" class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3\"></div>\n\n";
},"useData":true});
Handlebars.partials['svs-eurojackpot-components-play-system_rows_container'] = svs.eurojackpot.components.play.templates.system_rows_container;
})(svs, Handlebars);


 })(window);